export default __webpack_public_path__ + "static/media/ic-tool.634c068a.svg";